const VOWELS = "aąeęėiįyouųūAĄEĘĖIĮYOUŲŪ";
const STRESS = /[\u0300\u0301\u0303]/g;

const units = (text) => {
  const out = [];
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (/[\u0300-\u036f]/.test(ch) && out.length) out[out.length - 1].t += ch;
    else out.push({ t: ch, i });
  }
  return out;
};

const isLetter = (u) => /\p{L}/u.test(u.t[0]);

export const toggleStress = (text, index) => {
  const us = units(text.normalize("NFD"));
  const k = us.findIndex((u) => u.i === index);
  if (k < 0) return text;
  let a = k, b = k;
  while (a > 0 && isLetter(us[a - 1])) a--;
  while (b < us.length - 1 && isLetter(us[b + 1])) b++;
  const had = STRESS.test(us[k].t);
  STRESS.lastIndex = 0;
  for (let j = a; j <= b; j++) us[j].t = us[j].t.replace(STRESS, "");
  if (!had) us[k].t += "\u0301";
  return us.map((u) => u.t).join("").normalize("NFC");
};

export const StressView = ({ value, onChange }) => {
  const text = value.normalize("NFD");
  const us = units(text);
  const click = (u) => onChange(toggleStress(value.normalize("NFD"), u.i));
  return (
    <div data-testid="stress-view" className="font-mono text-sm leading-8 p-4 whitespace-pre-wrap max-h-[420px] overflow-auto scroll-thin">
      {us.map((u) => {
        if (u.t === "\n") return <br key={u.i} />;
        const vowel = VOWELS.includes(u.t[0]);
        const stressed = /[\u0300\u0301\u0303]/.test(u.t);
        if (!vowel) return <span key={u.i} className="text-zinc-400">{u.t.normalize("NFC")}</span>;
        return (
          <span key={u.i} data-testid={`stress-vowel-${u.i}`} onClick={() => click(u)}
            className={`cursor-pointer rounded px-[1px] transition-colors ${stressed ? "bg-[var(--c-orange)] text-white" : "text-zinc-100 hover:bg-[var(--c-violet)]/40"}`}>
            {u.t.normalize("NFC")}
          </span>
        );
      })}
    </div>
  );
};
